<template>
  <div class="md-form" v-if="typeof data !== 'undefined'">
    <i v-if="data.icon" class="fa prefix" v-bind:class="[data.icon]"></i>
    <input v-if="type === 'password'" v-on:blur="blur" type="password" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length && !data.untouched}" :disabled="isDisabled">
    <input v-if="type === 'hidden'" v-on:blur="blur" type="hidden" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length && !data.untouched}" :disabled="isDisabled">
    <input v-if="type === 'text'" v-on:blur="blur" type="text" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length && !data.untouched}" :disabled="isDisabled">
    <input v-if="type === 'number'" v-on:blur="blur" type="number" v-model="data.value" :id="data.name" class="form-control" v-bind:class="{invalid: data.errors.length && !data.untouched}" :disabled="isDisabled" :min="min" :max="max" :step="step">
    <textarea v-if="type === 'textarea'" v-on:blur="blur" type="text" v-model="data.value" :id="data.name" class="md-textarea" v-bind:class="{invalid: data.errors.length && !data.untouched}" :disabled="isDisabled" style="height: 100px;"></textarea>
    <label v-bind:class="{disabled: isDisabled}" :for="data.name">{{t(data.label)}}</label>
    <div v-if="data.explanation" class="explanation">
      <small>{{t(data.explanation)}}</small>
    </div>
    <transition name="slidedown">
    <div v-if="data.errors.length && !data.untouched" class="validationErrors">
      <small v-for="error in data.errors">
        {{t(error)}}
      </small>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'textInput',
  data() {
    return {
      shouldValidate: this.validate,
    };
  },
  props: {
    data: {},
    min: {
      default: 0,
    },
    step: {
      default: 1,
    },
    max: {
      default: undefined,
    },
    type: {
      default: 'text',
    },
    collection: {
      default: '',
    },
    index: {
      default: undefined,
    },
    autoSave: {
      default: false,
    },
  },
  computed: {
    isDisabled() {
      return this.data.disabled;
    },
    model() {
      return this.data.name;
    },
  },
  watch: {
    'data.value': function setErrors() {
      this.data.errors = {};
    },
  },
  mounted() {
  },
  methods: {
    blur() {
      this.data.untouched = false;
      let shouldValidate = true;
      if (typeof this.data.autoValidate !== 'undefined') {
        if (this.data.autoValidate === false) {
          shouldValidate = false;
        }
      }
      if (shouldValidate) {
        if (typeof this.collection !== 'undefined') {
          this.$store.dispatch('validateForm', {
            collection: this.collection,
            index: this.index,
            autoSave: this.autoSave,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.validationErrors {
}
</style>



// WEBPACK FOOTER //
// TextInput.vue?75cc0026